module.exports = __webpack_public_path__ + "static/media/SpirometryLab.98a44fcd.png";